module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-salons panel panel-default"
  }, [_c('panel-search', {
    attrs: {
      "placeholder": "Введите наименование автосалона для поиска"
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped",
    attrs: {
      "id": "result-form-search"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.salons), function(salon) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_ids),
        expression: "selected_ids"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("id-" + (salon.id))
      },
      domProps: {
        "value": salon.id,
        "checked": Array.isArray(_vm.selected_ids) ? _vm._i(_vm.selected_ids, salon.id) > -1 : (_vm.selected_ids)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected_ids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = salon.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.selected_ids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected_ids = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("id-" + (salon.id))
      }
    }, [_c('span')])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": ("/salons/" + (salon.id))
      }
    }, [_vm._v(_vm._s(salon.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s((salon.supervisor) ? salon.supervisor.full_name : ''))])])
  }), _vm._v(" "), (!_vm.salons.length) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Поиск")])]) : _vm._e()], 2)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.selected_salons), function(salon) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_ids),
        expression: "selected_ids"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("id-selected-" + (salon.id)),
        "name": _vm.name
      },
      domProps: {
        "value": salon.id,
        "checked": Array.isArray(_vm.selected_ids) ? _vm._i(_vm.selected_ids, salon.id) > -1 : (_vm.selected_ids)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected_ids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = salon.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.selected_ids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected_ids = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("id-selected-" + (salon.id))
      }
    }, [_c('span')])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": ("/salons/" + (salon.id))
      }
    }, [_vm._v(_vm._s(salon.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s((salon.supervisor) ? salon.supervisor.full_name : ''))])])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "selected-salons"
  }, [_vm._v("\n        Выбрано: "), _c('span', [_vm._v(_vm._s(_vm.selected_ids.length))]), _vm._v(" автосалона\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Салон")]), _vm._v(" "), _c('th', [_vm._v("ФИО супервайзера")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', [_vm._v("Выбранные салоны")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Салон")]), _vm._v(" "), _c('th', [_vm._v("ФИО супервайзера")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a2c09bd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2c09bd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SelectSalons.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a2c09bd8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SelectSalons.vue
// module chunks = 0